import { useEffect, useRef } from 'react'

import { SESSION_ACTIVITY_EVENTS } from '@/lib/sessionTimeout'

/**
 * Locks the session after `timeoutMs` of no user activity.
 *
 * @param {{ enabled: boolean, timeoutMs: number, onTimeout: () => void }} options
 */
export function useSessionTimeout({ enabled, timeoutMs, onTimeout }) {
  const onTimeoutRef = useRef(onTimeout)
  onTimeoutRef.current = onTimeout

  useEffect(() => {
    if (!enabled || timeoutMs <= 0) {
      return undefined
    }

    let timerId = window.setTimeout(() => {
      onTimeoutRef.current()
    }, timeoutMs)

    const resetTimer = () => {
      window.clearTimeout(timerId)
      timerId = window.setTimeout(() => {
        onTimeoutRef.current()
      }, timeoutMs)
    }

    for (const eventName of SESSION_ACTIVITY_EVENTS) {
      window.addEventListener(eventName, resetTimer, { passive: true })
    }

    return () => {
      window.clearTimeout(timerId)
      for (const eventName of SESSION_ACTIVITY_EVENTS) {
        window.removeEventListener(eventName, resetTimer)
      }
    }
  }, [enabled, timeoutMs])
}
